module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Create event","eventsActionsCreateSuccess":"%{eventTitle} was successfully added to the database"},"no":{"dialogTitle":"Opprett stevne","eventsActionsCreateSuccess":"%{eventTitle} ble lagt til i databasen"}}')
  delete Component.options._Ctor
}
